import styled from 'styled-components';

export const SearchBarBox = styled.div`
  display: flex;
  height: 40px;
  flex: 1;
  z-index: 2;
`;

export const SearchInput = styled.input`
  border: 0px solid black;
  background: #eee;
  margin: 0;
  padding: 10px;
  width: 100%;
  height: 20px;
`;
